import React from "react";
import './index.css'
import { useState, useEffect, useCallback } from 'react';
import EightLettersToWestenDate from "../EightLettersToWestenDate";
import GenderSelection from "../GenderSelection";
import DarkModeToggle from "../DarkModeToggle";
import { globalData } from "../../Helper/global";
import SolarTimeSelector from "../SolarTimeSelector";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import { useAuth } from '../../hooks/useAuth';

export default function ClientDataInput(props) {

    const [activeTab, setActiveTab] = useState(1);
    const [birthday, setBirthday] = useState();
    const [version, setVersion] = useState(process.env.REACT_APP_VERSION);
    const [openSolarTime, setOpenSolarTime] = useState(false);

    // ── Bookmark inline row state ─────────────────────────────────────────────
    const { user, bookmarks, addBookmark, updateBookmark, deleteBookmark, refreshBookmarks } = useAuth();
    const [bmName, setBmName] = useState('');
    const [bmRemark, setBmRemark] = useState('');
    const [matchedBookmark, setMatchedBookmark] = useState(null); // existing bookmark for current date
    const [bmLoading, setBmLoading] = useState(false);
    const [bmEditing, setBmEditing] = useState(false); // whether edit mode is active

    // Derive current active date (what is actually sent to server)
    const activeDate = props.inputDate;

    /**
     * When the effective input date / gender / bookmarks change,
     * find if there's already a bookmark matching the current query.
     */
    useEffect(() => {
        if (!user || !activeDate || props.requireDateComfirmation) {
            setMatchedBookmark(null);
            setBmName('');
            setBmRemark('');
            setBmEditing(false);
            return;
        }
        // Normalise to "YYYY-MM-DDTHH:MM" for comparison
        const norm = (dt) => dt ? dt.slice(0, 16) : '';
        const found = bookmarks.find(b =>
            norm(b.westernDatetime) === norm(activeDate) &&
            b.isMale === props.isMale
        );
        if (found) {
            setMatchedBookmark(found);
            setBmName(found.name || '');
            setBmRemark(found.remark || '');
            setBmEditing(false);
        } else {
            setMatchedBookmark(null);
            setBmName('');
            setBmRemark('');
            setBmEditing(false);
        }
    }, [user, activeDate, props.isMale, bookmarks, props.requireDateComfirmation]);

    const handleAddBookmark = useCallback(async () => {
        if (!activeDate) return;
        setBmLoading(true);
        try {
            await addBookmark({
                westernDatetime: activeDate,
                isMale: props.isMale,
                name: bmName,
                remark: bmRemark,
            });
        } catch (e) {
            console.error('Failed to add bookmark:', e);
        } finally {
            setBmLoading(false);
        }
    }, [activeDate, props.isMale, bmName, bmRemark, addBookmark]);

    const handleUpdateBookmark = useCallback(async () => {
        if (!matchedBookmark) return;
        setBmLoading(true);
        try {
            await updateBookmark(matchedBookmark.id, {
                westernDatetime: activeDate,
                isMale: props.isMale,
                name: bmName,
                remark: bmRemark,
            });
            setBmEditing(false);
        } catch (e) {
            console.error('Failed to update bookmark:', e);
        } finally {
            setBmLoading(false);
        }
    }, [matchedBookmark, activeDate, props.isMale, bmName, bmRemark, updateBookmark]);

    const handleDeleteBookmark = useCallback(async () => {
        if (!matchedBookmark) return;
        setBmLoading(true);
        try {
            await deleteBookmark(matchedBookmark.id);
            // Immediately reset UI — the useEffect will confirm via updated bookmarks array.
            setMatchedBookmark(null);
            setBmName('');
            setBmRemark('');
            setBmEditing(false);
            // Re-fetch from server so the menu list is also up-to-date.
            refreshBookmarks();
        } catch (e) {
            console.error('Failed to delete bookmark:', e);
        } finally {
            setBmLoading(false);
        }
    }, [matchedBookmark, deleteBookmark, refreshBookmarks]);
    
    // Initialize dark mode from localStorage
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            const savedMode = localStorage.getItem('darkMode');
            return savedMode === 'enabled';
        } catch (error) {
            console.error('Error loading dark mode preference:', error);
            return false;
        }
    });

    //get version number


    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };


    const handleDateChange = (e) => {
        if (!e.target['validity'].valid) return;
        setBirthday(e.target['value'])
        //for checking birthday and filter outdated server reply

        if (!props.requireDateComfirmation) { // require date confirmation, so won't query to server when date change.
            globalData.inputDate = e.target['value']
            props.setInputDate(e.target['value'])
            // props.getBirthDate(e.target['value'])
        }
    }

    const confirmBirthday = () => {  //when user click confirmation, update birthday to parent to query server 
        globalData.inputDate = birthday
        props.setInputDate(birthday)
    }

    return (
        <>
            <SolarTimeSelector
                openSolarTime={openSolarTime} setOpenSolarTime={setOpenSolarTime}
                birthday={birthday || props.inputDate} setBirthday={setBirthday}
            />

            <div className="tabs-container">
                <div className="tabs-header">
                    <button
                        className={activeTab === 1 ? 'active-tab' : ''}
                        onClick={() => { handleTabClick(1); props.onTitleClick?.(); }}
                    >
                        西曆出生日期
                    </button>
                    <button
                        className={activeTab === 2 ? 'active-tab' : ''}
                        onClick={() => handleTabClick(2)}
                    >
                        時辰八字
                    </button>
                </div>
                <div className="tab-content">
                    {activeTab === 1 && (
                        <>
                            <div className="grid-container">
                                <div>請輸入西曆出生日期</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div style={{ textAlign: "right" }}>
                                    <button onClick={() => {
                                        //props.getSolarTime(birthday)
                                        setOpenSolarTime(true)
                                    }}>轉換真太陽時</button>
                                </div>
                            </div>
                            <div className="grid-container">
                                <div className="grid-cell">(查詢前,請轉換真太陽時)</div>
                                <div>&nbsp;</div>
                            </div>
                            <div className="grid-container">
                                <div className="grid-cell">
                                    日期：<input type="datetime-local"
                                        className="input-datetime"
                                        value={birthday || props.inputDate || ''}
                                        onChange={handleDateChange}
                                    />
                                </div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>

                                <div className="grid-cell-align-right">
                                    <GenderSelection setIsMale={props.setIsMale} isMale={props.isMale} />
                                    &nbsp;&nbsp;
                                    <DarkModeToggle isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    
                                </div>
                            </div>

                            {/* ── Bookmark row (shown when logged-in and no confirmation needed) ── */}
                            {user && !props.requireDateComfirmation && props.inputDate && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', padding: '4px 2px' }}>
                                    <span style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>名稱：</span>
                                    <input
                                        type="text"
                                        value={bmName}
                                        onChange={e => { setBmName(e.target.value); if (matchedBookmark) setBmEditing(true); }}
                                        placeholder="書籤名稱"
                                        disabled={matchedBookmark && !bmEditing}
                                        style={{ flex: '1 1 80px', minWidth: '60px', maxWidth: '140px', padding: '5px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box' }}
                                    />
                                    <span style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>備注：</span>
                                    <input
                                        type="text"
                                        value={bmRemark}
                                        onChange={e => { setBmRemark(e.target.value); if (matchedBookmark) setBmEditing(true); }}
                                        placeholder="備注"
                                        disabled={matchedBookmark && !bmEditing}
                                        style={{ flex: '1 1 80px', minWidth: '60px', maxWidth: '140px', padding: '5px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box' }}
                                    />
                                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                        {!matchedBookmark ? (
                                            /* Add button */
                                            <button
                                                onClick={handleAddBookmark}
                                                disabled={bmLoading}
                                                title="新增書籤"
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px', minWidth: '44px', minHeight: '36px', padding: '5px 10px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                                            >
                                                <AddIcon style={{ fontSize: 16 }} />
                                            </button>
                                        ) : !bmEditing ? (
                                            /* Edit & Delete buttons */
                                            <>
                                                <button
                                                    onClick={() => setBmEditing(true)}
                                                    title="編輯書籤"
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '36px', minHeight: '36px', padding: '5px 8px', background: '#f5a623', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                                                >
                                                    <EditIcon style={{ fontSize: 16 }} />
                                                </button>
                                                <button
                                                    onClick={handleDeleteBookmark}
                                                    disabled={bmLoading}
                                                    title="刪除書籤"
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '36px', minHeight: '36px', padding: '5px 8px', background: '#e53935', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                                                >
                                                    <DeleteIcon style={{ fontSize: 16 }} />
                                                </button>
                                            </>
                                        ) : (
                                            /* Save & Cancel buttons when editing */
                                            <>
                                                <button
                                                    onClick={handleUpdateBookmark}
                                                    disabled={bmLoading}
                                                    title="儲存書籤"
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px', minWidth: '44px', minHeight: '36px', padding: '5px 10px', background: '#43a047', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                                                >
                                                    <CheckIcon style={{ fontSize: 16 }} />
                                                </button>
                                                <button
                                                    onClick={() => { setBmEditing(false); setBmName(matchedBookmark.name || ''); setBmRemark(matchedBookmark.remark || ''); }}
                                                    title="取消"
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '44px', minHeight: '36px', padding: '5px 10px', background: '#bbb', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}
                                                >
                                                    X
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div style={{ textAlign: "right", fontSize: "10px" }}
                                onClick={() => { setVersion(window.innerWidth) }}
                            >Adacs v{version}</div>

                            {props.requireDateComfirmation &&
                                <button disabled={birthday === undefined || birthday.length === 0}
                                    onClick={() => { confirmBirthday() }} >查詢</button>}
                        </>

                    )}
                    {activeTab === 2 && (
                        <>
                            <EightLettersToWestenDate
                                // getBirthDate={props.getBirthDate}
                                setInputDate={props.setInputDate}
                                isMale={props.isMale} setIsMale={props.setIsMale}
                                isActive={activeTab === 2} />
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
